import { createAction, props } from '@ngrx/store';

import { SessionUser } from 'app/core/models';

const enum AuthActionTypes {
    UpdateSessionUser = '[Auth] Update Session User',
}

export const updateSessionUser = createAction(AuthActionTypes.UpdateSessionUser, props<{ sessionUser: SessionUser }>());
